<template>
  <div
    class="container navigate-top-left"
    :class="{ hasTop: hasTop, hasLeft: hasLeft, collapsed: isCollapse }"
  >
    <div
      class="top-wrapper"
      id="secondMenu"
      v-if="hasTop"
    >
      <el-tabs
        v-model="secondActive"
        type="card-elip"
        class="second-menu-tabs"
        @tab-click="secondClick"
        v-if="hasTop"
      >
        <el-tab-pane
          v-for="menu in firstChildren"
          :label="menu.name"
          :name="menu._path"
          :key="menu.menuId"
        >
        </el-tab-pane>
      </el-tabs>
    </div>
    <div
      class="bottom-wrapper"
      id="secondBottomWrapper"
    >
      <div
        class="left-wrapper nav-left-menu"
        v-show="hasLeft"
      >
        <el-scrollbar class="auto-height-scrollbar dark">
          <el-menu
            ref="leftMenu"
            :collapse="isCollapse"
            :collapse-btn="true"
            :router="true"
            wrap-scroll
            @click-collapse="onClickCollapseBtn"
          >
            <el-menu-item
              :index="menu._path"
              v-for="menu in secondChildren"
              :key="menu.menuId"
            >
              <img
                class="icon"
                slot="icon"
                :src="menu.iconInfo.path"
                :onerror="defaultIcon"
              />
              {{ menu.name }}
            </el-menu-item>
          </el-menu>
        </el-scrollbar>
      </div>
      <div class="right-wrapper">
        <common-iframe
          :srcInfo="frameSrc"
          frameborder="0"
          v-if="frameSrc !== ''"
        ></common-iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { autoCloseMenu } from 'utils/mixin'
import commonIframe from '../view-page/common-iframe'
export default {
  name: 'navigate-top-left',
  components: { commonIframe },
  props: {
    userName: String
  },
  computed: {
    ...mapGetters(['navigateSchema', 'appMenus']),
    activeMenu () {
      let _map = {
        firstMenu: null,
        secondMenu: null,
        thirdMenu: null
      }
      if (this.$route.params.first) {
        _map.firstMenu = this._getMenu(this.appMenus, this.$route.params.first)
      }
      if (_map.firstMenu) {
        if (this.$route.params.second) {
          _map.secondMenu = this._getMenu(
            _map.firstMenu.children,
            this.$route.params.second
          )
        } else if (_map.firstMenu.children.length) {
          _map.secondMenu = _map.firstMenu.children[0]
        }
      }
      if (_map.secondMenu) {
        if (this.$route.params.third) {
          _map.thirdMenu = this._getMenu(
            _map.secondMenu.children,
            this.$route.params.third
          )
        } else if (_map.secondMenu.children.length) {
          _map.thirdMenu = _map.secondMenu.children[0]
        }
      }
      return _map
    },
    tlncParams () {
      return JSON.stringify(this.$storage.get('tlncParams'))
    },
    hasTop () {
      return this.activeMenu.firstMenu && this.activeMenu.firstMenu._hasChild
    },
    hasLeft () {
      return this.activeMenu.secondMenu && this.activeMenu.secondMenu._hasChild && !this.activeMenu.secondMenu.fullUrl
    },
    frameSrc () {
      if (this.activeMenu.thirdMenu) {
        if (this.activeMenu.thirdMenu.openType === 2) {
          window.open(this.activeMenu.thirdMenu.fullUrl)
          this.$router.go(-1)
          return ''
        } else {
          return this.activeMenu.thirdMenu.fullUrl
        }
      }
      if (this.activeMenu.secondMenu) {
        if (this.activeMenu.secondMenu.openType === 2) {
          window.open(this.activeMenu.secondMenu.fullUrl)
          this.$router.go(-1)
          return ''
        } else {
          return this.activeMenu.secondMenu.fullUrl
        }
      }
      if (this.activeMenu.firstMenu) {
        if (this.activeMenu.firstMenu.openType === 2) {
          window.open(this.activeMenu.firstMenu.fullUrl)
          this.$router.go(-1)
          return ''
        } else {
          return this.activeMenu.firstMenu.fullUrl
        }
      }
      return ''
    },
    firstChildren () {
      return this.activeMenu.firstMenu
        ? this.activeMenu.firstMenu.children
        : []
    },
    secondChildren () {
      return this.activeMenu.secondMenu
        ? this.activeMenu.secondMenu.children
        : []
    }
  },
  data () {
    return {
      defaultIcon: `this.src="${require('../../assets/images/nav_icondefault_B.png')}"`,
      secondActive: '',
      isCollapse: false
    }
  },
  watch: {
    '$route.params' () {
      this.secondActive =
        this.activeMenu.secondMenu && this.activeMenu.secondMenu._path
      this.$nextTick(() => {
        if (this.activeMenu.thirdMenu && this.$refs.leftMenu) {
          this.$refs.leftMenu.activeIndex = this.activeMenu.thirdMenu._path
        }
      })
    }
  },
  methods: {
    _getMenu (arr, id) {
      let _menu = null
      if (!arr || arr.length < 0 || !id) return _menu
      arr.forEach(item => {
        if (item.menuId === id) {
          _menu = item
        }
      })
      return _menu
    },
    secondClick (tab) {
      this.$router.push(tab.name)
    },
    onClickCollapseBtn (flag) {
      if (flag) {
        this.isCollapse = flag
      } else {
        this.isCollapse = !this.isCollapse
      }
    }
  },
  mounted () {
    this._autoCloseMenu()
    this.$nextTick(() => {
      if (this.hasTop) {
        this.secondActive = this.activeMenu.secondMenu._path
      }
      if (this.activeMenu.thirdMenu && this.$refs.leftMenu) {
        this.$refs.leftMenu.activeIndex = this.activeMenu.thirdMenu._path
      }
      top.window.extendScreen_closeMenu = this.onClickCollapseBtn
    })
  },
  mixins: [autoCloseMenu]
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.navigate-top-left.container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .bottom-wrapper {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    .right-wrapper {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      iframe {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
  &.hasTop {
    .top-wrapper {
      height: 40px;
      padding: 4px 16px;
      box-sizing: border-box;
      position: relative;
      z-index: 999;
      box-shadow: 0 2px 4px 0 rgba(154, 173, 173, 0.2);
    }
    .bottom-wrapper {
      top: 40px;
    }
  }
  &.hasLeft {
    .left-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 240px;
      overflow: auto;
    }
    .right-wrapper {
      left: 240px;
    }
    &.collapsed {
      .left-wrapper {
        width: 48px;
      }
      .right-wrapper {
        left: 48px;
      }
    }
  }
}
</style>
